import React from 'react'
import { useSelector } from 'react-redux';

export default function useLobbyBuyIn() {
    const buyInDetails = useSelector((state) => state.lobby.lobbyBuyInDetails);

    if (!buyInDetails?.visible || !buyInDetails?.gameDefinition) {
        return {
            visible: false,
            gameDefinition: {}
        }
    }

    return buyInDetails
}
